import { createContext, useContext, useState, useCallback } from "react";

const STORAGE_KEY = "pb_lang";

export const translations = {
  sk: {
    // nav / header
    "nav.home": "Domov",
    "nav.archive": "Archív",
    "nav.admin": "Administrácia",
    "nav.login": "Prihlásiť sa",
    "nav.adminPanel": "Admin Panel",
    "nav.logout": "Odhlásiť sa",
    "title.home": "Remeselný Batch Tracker | overujpreveruj.sk",
    "title.archive": "Archív produktov a surovín | overujpreveruj.sk",
    "title.brand": "overujpreveruj.sk",
    "title.batchLabel": "Šarža",
    "title.ingredientSuffix": "Prehľad suroviny",
    "title.login": "Prihlásenie správcu | overujpreveruj.sk",
    "title.dashboard": "Admin Panel | overujpreveruj.sk",
    // dev banner
    "banner.dev":
      "Webová stránka je momentálne vo vývoji. Ďakujeme za pochopenie pri prípadných nepresnostiach alebo výpadkoch. V prípade akýchkoľvek otázok nás neváhajte kontaktovať.",
    // hero
    "hero.badge": "Otvorená sledovateľnosť",
    "hero.title1": "Transparentná",
    "hero.title2": "remeselná dielňa.",
    "hero.subtitle":
      "Vitajte vo verejnej evidencii šarží a spracovaných materiálov. Každý výrobok má svoj kód, fotografiu, dátum produkcie a úplný zoznam zložiek, ktoré si viete spätne overiť až k dodávateľovi.",
    "cta.search": "Vyhľadať šaržu podľa kódu",
    "cta.browse": "Prehliadať históriu produktov a surovín",
    // how it works
    "how.kicker": "Ako to funguje",
    "how.title": "Tri kroky k úplnej transparentnosti",
    "how.s1.title": "Naskenujte kód šarže",
    "how.s1.text": "Na obale každého produktu nájdete QR kód alebo kód šarže (napr. BATCH-2026-01).",
    "how.s2.title": "Pozrite si zloženie",
    "how.s2.text": "Zobrazí sa úplný INCI zoznam surovín spolu s ich bio statusom a kategóriou.",
    "how.s3.title": "Overte pôvod",
    "how.s3.text": "Pri každej surovine je odkaz priamo na dodávateľa — nič neostáva skryté.",
    "how.archiveLink": "Prejsť do archívu produktov",
    // subscriptions
    "subs.kicker": "Zostaňte informovaní",
    "subs.title": "Odoberajte upozornenia",
    "crisis.title": "Prihlásiť sa na odber dôležitých upozornení",
    "crisis.desc":
      "Tento zoznam slúži výhradne na naliehavé a dôležité upozornenia v prípade, že by sa zistila chyba vo výrobnom procese alebo iný závažný problém. E-mailové adresy sú bezpečne uložené v našej internej databáze a nebudú použité na zasielanie reklamy ani nevyžiadaných správ.",
    "marketing.title": "Prihlásiť sa na odber noviniek",
    "marketing.desc":
      "Tento zoznam je určený pre verných zákazníkov. Posielame naň informácie o nových várkach, naskladnených surovinách a ďalších novinkách z našej dielne. Správy zasielame s rozvahou a v primeranej frekvencii.",
    "tech.notice.label": "Poznámka k vývoju:",
    "tech.notice.text":
      "Systém je v aktívnom vývoji, preto sa môžu vyskytnúť drobné nepresnosti. Ďakujeme za vašu trpezlivosť a pochopenie. V budúcnosti plánujeme pridať SMS upozornenia a rozšírené nastavenia profilu.",
    // subscribe form
    "sub.placeholder": "vas@email.sk",
    "sub.button": "Prihlásiť",
    "sub.success": "Ďakujeme! E-mail bol pridaný.",
    "sub.addAnother": "pridať ďalší",
    "sub.already": "Tento e-mail je už prihlásený na odber.",
    "sub.done": "Úspešne prihlásené.",
    "sub.error": "Prihlásenie zlyhalo",
    // archive
    "archive.kicker": "Archív",
    "archive.title": "História produktov a surovín",
    "archive.tab.products": "Produkty (šarže)",
    "archive.tab.ingredients": "Suroviny",
    "archive.search.placeholder": "napr. BATCH-2026-01 alebo názov produktu",
    "archive.search.button": "Hľadať",
    "archive.search.clear": "Zrušiť",
    "archive.recent": "Naposledy hľadané",
    "archive.empty.title": "Žiadne šarže",
    "archive.empty.search": "Skúste iný kód alebo názov produktu.",
    "archive.empty.default": "Tu sa zobrazia publikované šarže.",
    "archive.ing.empty": "Žiadne suroviny",
    "archive.sort.label": "Zoradiť",
    "archive.sort.newest": "Najnovšie po najstaršie",
    "archive.sort.oldest": "Najstaršie po najnovšie",
    "archive.filter.tag": "Štítok",
    "archive.filter.category": "Kategória",
    "archive.filter.all": "Všetky",
    "archive.filter.reset": "Zrušiť filtre",
    "common.verify": "Overiť",
    // batch page
    "batch.back": "Archív",
    "batch.verified": "Overená šarža",
    "batch.produced": "Vyrobené",
    "batch.qr.scan": "Skenovaním overíte",
    "batch.qr.print": "Vytlačte na obal produktu.",
    "batch.qr.download": "Stiahnuť QR",
    "batch.inci.kicker": "Úplné overenie INCI",
    "batch.inci.title": "Suroviny a zdroje",
    "batch.inci.listed": "položiek",
    "batch.table.ingredient": "Surovina (INCI)",
    "batch.table.bio": "Bio status",
    "batch.table.supplier": "Dodávateľ",
    "batch.table.content": "Obsah",
    "batch.content.label": "Obsah",
    "batch.percent.unknown": "Nezistené",
    "batch.cert.certified": "Certifikovaná šarža",
    "batch.cert.uncertified": "Garážová / Necertifikovaná šarža",
    "bd.weight": "Množstvo v gramoch",
    "bd.totalWeight": "Celková hmotnosť",
    "bd.certified": "Certifikovaný výrobok",
    "batch.noSource": "Bez zdroja",
    "batch.notfound.title": "Šarža nenájdená",
    "batch.notfound.text": "Nepodarilo sa nájsť publikovanú šaržu s týmto kódom.",
    "batch.notfound.back": "Späť do archívu",
    "batchsub.title": "Prihlásiť sa na upozornenia pre túto konkrétnu šaržu",
    "batchsub.desc":
      "Tento odber slúži výhradne na upozornenia v prípade, že by sa zistil problém alebo chyba vo výrobnom procese práve pri tejto konkrétnej šarži. Nebudete dostávať žiadne iné všeobecné správy.",
    // ingredient page
    "ing.back": "Suroviny",
    "ing.verifySupplier": "Overiť dodávateľa",
    "ing.reverse.kicker": "Spätné prepojenie",
    "ing.reverse.title": "Dostupné produkty s touto surovinou",
    "ing.noBatches": "Zatiaľ žiadny produkt nepoužíva túto surovinu.",
    "ing.notfound": "Surovina nenájdená",
    "ing.notfound.back": "Späť na suroviny",
    // admin login
    "login.title": "Prístup pre administrátora",
    "login.subtitle": "Vyhradená oblasť. Len pre oprávnené osoby.",
    "login.email": "E-mail",
    "login.password": "Heslo",
    "login.submit": "Prihlásiť sa",
    "login.submitting": "Prihlasujem…",
    "login.back": "Späť na verejnú stránku",
    "login.welcome": "Vitajte späť",
    // admin dashboard
    "admin.center": "Riadiace centrum",
    "admin.dbtitle": "Správa databázy",
    "admin.logout": "Odhlásiť",
    "admin.tab.batches": "Šarže",
    "admin.tab.ingredients": "Suroviny",
    "admin.tab.emails": "Správa e-mailov",
    "admin.newBatch": "Nová šarža",
    "admin.noBatches": "Zatiaľ žiadne šarže",
    "admin.ingCount": "surovín",
    "admin.tip.public": "Verejná stránka",
    "admin.tip.openIng": "Otvoriť surovinu v novej karte",
    "admin.tip.clone": "Klonovať",
    "admin.tip.edit": "Upraviť",
    "admin.tip.delete": "Odstrániť",
    "admin.newIngredient": "Nová surovina",
    "admin.noIngredients": "Zatiaľ žiadne suroviny",
    // batch dialog
    "bd.editTitle": "Upraviť šaržu",
    "bd.createTitle": "Nová šarža",
    "bd.desc": "Vyberte suroviny zo zoznamu. Publikovaním sa šarža okamžite zobrazí na verejnej stránke.",
    "bd.code": "Kód šarže",
    "bd.date": "Dátum výroby",
    "bd.name": "Názov produktu",
    "bd.photo": "Fotografia produktu",
    "bd.upload": "Nahrať",
    "bd.uploading": "Nahrávam…",
    "bd.ingredients": "Suroviny",
    "bd.selected": "vybraných",
    "bd.noIngHint": "Najprv pridajte suroviny v záložke „Suroviny“.",
    "bd.searchIng": "Hľadať surovinu…",
    "bd.notFound": "Nič nenájdené",
    "bd.publish": "Publikovať",
    "bd.save": "Uložiť zmeny",
    "common.cancel": "Zrušiť",
    "clone.toast": "Recept naklonovaný — zadajte nový kód šarže",
    "clone.ing.toast": "Surovina naklonovaná — upravte a uložte ako novú",
    "admin.tip.cloneIng": "Klonovať surovinu",
    "img.add": "Pridať",
    "img.primary": "Hlavná",
    "img.makePrimary": "Nastaviť",
    "img.setPrimary": "Nastaviť ako hlavnú fotografiu",
    "bd.images": "Fotografie produktu",
    "bd.checkDosage": "Kontrolovať výpočet dávkovania",
    "id.images": "Fotografie suroviny",
    "id.dosage": "Max. odporúčané dávkovanie (%)",
    "id.dosagePlaceholder": "napr. 1",
    "id.anyDosage": "Zvoliť hocikoľko (bez limitu dávkovania)",
    "tag.description": "Popis štítku (vysvetlenie)",
    "tag.descPlaceholder": "Napr. čo znamená „Experiment“ alebo „Legacy“…",
    "tag.inheritance": "Režim dedenia (surovina → šarža)",
    "tag.inheritance.any": "Akákoľvek prítomnosť",
    "tag.inheritance.threshold": "Percentuálny prah (súčet %)",
    "tag.inheritance.hint.any": "Šarža zdedí štítok, ak ho má aspoň jedna surovina.",
    "tag.inheritance.hint.threshold": "Šarža zdedí štítok, ak súčet % surovín s týmto štítkom dosiahne prah.",
    "tag.minPercent": "Min. súčet % vyžadovaný",
    "batch.inheritedTags": "Vlastnosti šarže (odvodené zo surovín)",
    "dosage.undefined": "Nezistené / Nenahodené odporúčané dávkovanie",
    "dosage.exceeded.short": "Prekročené dávkovanie",
    "dosage.exceeded.box": "POZOR: Prekročené odporúčané bezpečné dávkovanie suroviny!",
    "dosage.exceeded.detail": "Nasledujúce suroviny presahujú odporúčané bezpečné dávkovanie:",
    // ingredient dialog
    "id.editTitle": "Upraviť surovinu",
    "id.createTitle": "Nová surovina",
    "id.desc": "Suroviny sa dajú opakovane použiť vo viacerých šaržiach.",
    "id.name": "Názov",
    "id.category": "Kategória",
    "id.selectCategory": "Vyberte kategóriu",
    "id.description": "Popis",
    "id.descPlaceholder": "Krátky popis suroviny a jej účinkov…",
    "id.bio": "Bio status",
    "id.url": "URL dodávateľa",
    "id.add": "Pridať surovinu",
    "id.save": "Uložiť zmeny",
    // delete dialogs
    "del.batch.title": "Odstrániť šaržu?",
    "del.batch.desc": "Šarža bude natrvalo odstránená z verejného archívu.",
    "del.ing.title": "Odstrániť surovinu?",
    "del.ing.desc": "Surovina bude odstránená a tiež odobratá zo všetkých šarží, ktoré ju používajú.",
    "del.confirm": "Odstrániť",
    // email management
    "em.count.crisis": "Dôležité upozornenia",
    "em.count.marketing": "Novinky pre zákazníkov",
    "em.count.batch": "Odberatelia šarží",
    "em.export": "Exportovať do CSV",
    "em.title": "Hromadný e-mail",
    "em.privacy":
      "E-maily sa odosielajú jednotlivo / ako skrytá kópia (BCC) — odberatelia sa navzájom nevidia.",
    "em.mockNote":
      "Odosielanie naživo cez službu Resend z adresy info@overujpreveruj.sk. Doručenie vyžaduje overenú doménu a nastavený kľúč RESEND_API_KEY.",
    "em.history.title": "História odoslaní",
    "em.history.empty": "Zatiaľ žiadne odoslané kampane.",
    "em.status.sent": "Odoslané",
    "em.status.partial": "Čiastočne",
    "em.status.failed": "Zlyhalo",
    "em.status.not_configured": "Nenakonfigurované",
    "em.target": "Cieľový zoznam",
    "em.opt.crisis": "Dôležité upozornenia",
    "em.opt.marketing": "Novinky pre zákazníkov",
    "em.opt.batch": "Odberatelia konkrétnej šarže",
    "em.batch": "Šarža",
    "em.selectBatch": "Vyberte kód šarže",
    "em.subject": "Predmet",
    "em.subjectPlaceholder": "Dôležité upozornenie k šarži…",
    "em.body": "Správa",
    "em.bodyPlaceholder": "Text hromadného e-mailu…",
    "em.send": "Poslať hromadný e-mail",
    // toasts
    "toast.batchPublished": "Šarža publikovaná — teraz je naživo!",
    "toast.batchUpdated": "Šarža upravená",
    "toast.batchDeleted": "Šarža odstránená",
    "toast.ingAdded": "Surovina pridaná",
    "toast.ingUpdated": "Surovina upravená",
    "toast.ingDeleted": "Surovina odstránená",
    "toast.photoUploaded": "Fotografia nahraná",
    "toast.selectCategory": "Vyberte kategóriu",
    "toast.selectBatch": "Vyberte šaržu",
    "toast.exported": "Exportovaných {n} záznamov",
    "toast.exportEmpty": "Zoznam je prázdny — nič na export.",
    "toast.exportFail": "Export zlyhal",
    "toast.saveFail": "Uloženie zlyhalo",
    "toast.deleteFail": "Odstránenie zlyhalo",
    "toast.uploadFail": "Nahranie zlyhalo",
    "toast.sendFail": "Odoslanie zlyhalo",
    // footer
    "admin.tab.tags": "Štítky",
    "admin.newTag": "Nový štítok",
    "admin.noTags": "Zatiaľ žiadne štítky",
    "tag.name": "Názov štítku",
    "tag.color": "Farba pozadia",
    "tag.create": "Vytvoriť štítok",
    "tag.save": "Uložiť zmeny",
    "tag.editTitle": "Upraviť štítok",
    "tag.createTitle": "Nový štítok",
    "tag.preview": "Náhľad",
    "del.tag.title": "Odstrániť štítok?",
    "del.tag.desc": "Štítok bude odstránený zo všetkých surovín, ktoré ho používajú.",
    "id.tags": "Štítky",
    "id.noTags": "Najprv vytvorte štítky v záložke „Štítky“.",
    "toast.tagAdded": "Štítok vytvorený",
    "toast.tagUpdated": "Štítok upravený",
    "toast.tagDeleted": "Štítok odstránený",
    "footer.lastUpdate": "Posledná aktualizácia systému:",
    "footer.tagline": "OTVORENÁ EVIDENCIA ŠARŽÍ A MATERIÁLOV",
  },
  en: {
    "nav.home": "Home",
    "nav.archive": "Archive",
    "nav.admin": "Administration",
    "nav.login": "Sign in",
    "nav.adminPanel": "Admin Panel",
    "nav.logout": "Log out",
    "title.home": "Craft Batch Tracker | overujpreveruj.sk",
    "title.archive": "Product & ingredient archive | overujpreveruj.sk",
    "title.brand": "overujpreveruj.sk",
    "title.batchLabel": "Batch",
    "title.ingredientSuffix": "Ingredient overview",
    "title.login": "Administrator login | overujpreveruj.sk",
    "title.dashboard": "Admin Panel | overujpreveruj.sk",
    "banner.dev":
      "This website is currently under development. Thank you for your understanding regarding any inaccuracies or outages. Please do not hesitate to contact us with any questions.",
    "hero.badge": "Open Traceability",
    "hero.title1": "Transparent",
    "hero.title2": "craft workshop.",
    "hero.subtitle":
      "Welcome to the public registry of batches and processed materials. Every product has its own code, photo, production date and a full list of components you can trace back to the supplier.",
    "cta.search": "Search a batch by code",
    "cta.browse": "Browse product & ingredient history",
    "how.kicker": "How it works",
    "how.title": "Three steps to full transparency",
    "how.s1.title": "Scan the batch code",
    "how.s1.text": "On every product label you will find a QR code or a batch code (e.g. BATCH-2026-01).",
    "how.s2.title": "Review the composition",
    "how.s2.text": "The full INCI list of ingredients is shown, along with their bio status and category.",
    "how.s3.title": "Verify the origin",
    "how.s3.text": "Every ingredient links directly to its supplier — nothing stays hidden.",
    "how.archiveLink": "Go to product archive",
    "subs.kicker": "Stay informed",
    "subs.title": "Subscribe to notifications",
    "crisis.title": "Subscribe to important notifications",
    "crisis.desc":
      "This list is used exclusively for urgent and important notifications in the event that a fault in the production process or another serious problem is identified. Email addresses are securely stored in our internal database and will never be used for advertising or unsolicited messages.",
    "marketing.title": "Subscribe to news",
    "marketing.desc":
      "This list is intended for loyal customers. We send information about new batches, newly stocked ingredients and other news from our workshop. We send messages thoughtfully and at a reasonable frequency.",
    "tech.notice.label": "Development note:",
    "tech.notice.text":
      "The system is under active development, so minor inaccuracies may occur. Thank you for your patience and understanding. In the future we plan to add SMS notifications and extended profile settings.",
    "sub.placeholder": "your@email.com",
    "sub.button": "Subscribe",
    "sub.success": "Thank you! Your email was added.",
    "sub.addAnother": "add another",
    "sub.already": "This email is already subscribed.",
    "sub.done": "Successfully subscribed.",
    "sub.error": "Subscription failed",
    "archive.kicker": "Archive",
    "archive.title": "Product & ingredient history",
    "archive.tab.products": "Products (batches)",
    "archive.tab.ingredients": "Ingredients",
    "archive.search.placeholder": "e.g. BATCH-2026-01 or product name",
    "archive.search.button": "Search",
    "archive.search.clear": "Clear",
    "archive.recent": "Recent searches",
    "archive.empty.title": "No batches",
    "archive.empty.search": "Try a different code or product name.",
    "archive.empty.default": "Published batches will appear here.",
    "archive.ing.empty": "No ingredients",
    "archive.sort.label": "Sort",
    "archive.sort.newest": "Newest to oldest",
    "archive.sort.oldest": "Oldest to newest",
    "archive.filter.tag": "Tag",
    "archive.filter.category": "Category",
    "archive.filter.all": "All",
    "archive.filter.reset": "Clear filters",
    "common.verify": "Verify",
    "batch.back": "Archive",
    "batch.verified": "Verified batch",
    "batch.produced": "Produced",
    "batch.qr.scan": "Scan to verify",
    "batch.qr.print": "Print on the product label.",
    "batch.qr.download": "Download QR",
    "batch.inci.kicker": "Full INCI verification",
    "batch.inci.title": "Ingredients & sources",
    "batch.inci.listed": "items",
    "batch.table.ingredient": "Ingredient (INCI)",
    "batch.table.bio": "Bio status",
    "batch.table.supplier": "Supplier",
    "batch.table.content": "Content",
    "batch.content.label": "Content",
    "batch.percent.unknown": "Not specified",
    "batch.cert.certified": "Certified batch",
    "batch.cert.uncertified": "Homemade / Uncertified batch",
    "bd.weight": "Weight in grams",
    "bd.totalWeight": "Total weight",
    "bd.certified": "Certified product",
    "batch.noSource": "No source",
    "batch.notfound.title": "Batch not found",
    "batch.notfound.text": "We couldn't find a published batch with this code.",
    "batch.notfound.back": "Back to archive",
    "batchsub.title": "Subscribe to alerts for this specific batch",
    "batchsub.desc":
      "This subscription is used exclusively for alerts in the event that a problem or fault in the production process is identified for this specific batch. You will not receive any other general messages.",
    "ing.back": "Ingredients",
    "ing.verifySupplier": "Verify supplier",
    "ing.reverse.kicker": "Cross-reference",
    "ing.reverse.title": "Products using this ingredient",
    "ing.noBatches": "No product uses this ingredient yet.",
    "ing.notfound": "Ingredient not found",
    "ing.notfound.back": "Back to ingredients",
    "login.title": "Administrator access",
    "login.subtitle": "Restricted area. Authorized personnel only.",
    "login.email": "Email",
    "login.password": "Password",
    "login.submit": "Sign in",
    "login.submitting": "Signing in…",
    "login.back": "Back to public site",
    "login.welcome": "Welcome back",
    "admin.center": "Control center",
    "admin.dbtitle": "Database management",
    "admin.logout": "Log out",
    "admin.tab.batches": "Batches",
    "admin.tab.ingredients": "Ingredients",
    "admin.tab.emails": "Email management",
    "admin.newBatch": "New batch",
    "admin.noBatches": "No batches yet",
    "admin.ingCount": "ingredients",
    "admin.tip.public": "Public page",
    "admin.tip.openIng": "Open ingredient in new tab",
    "admin.tip.clone": "Clone",
    "admin.tip.edit": "Edit",
    "admin.tip.delete": "Delete",
    "admin.newIngredient": "New ingredient",
    "admin.noIngredients": "No ingredients yet",
    "bd.editTitle": "Edit batch",
    "bd.createTitle": "New batch",
    "bd.desc": "Select ingredients from the list. Publishing makes the batch instantly visible on the public site.",
    "bd.code": "Batch code",
    "bd.date": "Production date",
    "bd.name": "Product name",
    "bd.photo": "Product photo",
    "bd.upload": "Upload",
    "bd.uploading": "Uploading…",
    "bd.ingredients": "Ingredients",
    "bd.selected": "selected",
    "bd.noIngHint": "First add ingredients in the “Ingredients” tab.",
    "bd.searchIng": "Search ingredient…",
    "bd.notFound": "Nothing found",
    "bd.publish": "Publish",
    "bd.save": "Save changes",
    "common.cancel": "Cancel",
    "clone.toast": "Recipe cloned — enter a new batch code",
    "clone.ing.toast": "Ingredient cloned — edit and save as new",
    "admin.tip.cloneIng": "Clone ingredient",
    "img.add": "Add",
    "img.primary": "Primary",
    "img.makePrimary": "Set",
    "img.setPrimary": "Set as primary photo",
    "bd.images": "Product photos",
    "bd.checkDosage": "Check dosage calculation",
    "id.images": "Ingredient photos",
    "id.dosage": "Max recommended dosage (%)",
    "id.dosagePlaceholder": "e.g. 1",
    "id.anyDosage": "Allow any amount (no dosage limit)",
    "tag.description": "Tag description (explanation)",
    "tag.descPlaceholder": "E.g. what 'Experiment' or 'Legacy' means…",
    "tag.inheritance": "Inheritance mode (ingredient → batch)",
    "tag.inheritance.any": "Any presence",
    "tag.inheritance.threshold": "Percentage threshold (sum %)",
    "tag.inheritance.hint.any": "The batch inherits the tag if at least one ingredient carries it.",
    "tag.inheritance.hint.threshold": "The batch inherits the tag if the combined % of ingredients with this tag reaches the threshold.",
    "tag.minPercent": "Min. combined % required",
    "batch.inheritedTags": "Batch properties (derived from ingredients)",
    "dosage.undefined": "Unknown / recommended dosage not set",
    "dosage.exceeded.short": "Dosage exceeded",
    "dosage.exceeded.box": "WARNING: The recommended safe dosage of an ingredient has been exceeded!",
    "dosage.exceeded.detail": "The following ingredients exceed the recommended safe dosage:",
    "id.editTitle": "Edit ingredient",
    "id.createTitle": "New ingredient",
    "id.desc": "Ingredients can be reused across multiple batches.",
    "id.name": "Name",
    "id.category": "Category",
    "id.selectCategory": "Select a category",
    "id.description": "Description",
    "id.descPlaceholder": "A short description of the ingredient and its effects…",
    "id.bio": "Bio status",
    "id.url": "Supplier URL",
    "id.add": "Add ingredient",
    "id.save": "Save changes",
    "del.batch.title": "Delete this batch?",
    "del.batch.desc": "The batch will be permanently removed from the public archive.",
    "del.ing.title": "Delete this ingredient?",
    "del.ing.desc": "The ingredient will be deleted and also removed from all batches that use it.",
    "del.confirm": "Delete",
    "em.count.crisis": "Important notifications",
    "em.count.marketing": "Customer news",
    "em.count.batch": "Batch subscribers",
    "em.export": "Export to CSV",
    "em.title": "Mass email",
    "em.privacy":
      "Emails are sent individually / as blind carbon copy (BCC) — subscribers never see each other.",
    "em.mockNote":
      "Sent live via Resend from info@overujpreveruj.sk. Delivery requires a verified domain and a configured RESEND_API_KEY.",
    "em.history.title": "Send history",
    "em.history.empty": "No campaigns sent yet.",
    "em.status.sent": "Sent",
    "em.status.partial": "Partial",
    "em.status.failed": "Failed",
    "em.status.not_configured": "Not configured",
    "em.target": "Target list",
    "em.opt.crisis": "Important notifications",
    "em.opt.marketing": "Customer news",
    "em.opt.batch": "Subscribers of a specific batch",
    "em.batch": "Batch",
    "em.selectBatch": "Select a batch code",
    "em.subject": "Subject",
    "em.subjectPlaceholder": "Important notice regarding batch…",
    "em.body": "Message",
    "em.bodyPlaceholder": "Mass email text…",
    "em.send": "Send mass email",
    "toast.batchPublished": "Batch published — now live!",
    "toast.batchUpdated": "Batch updated",
    "toast.batchDeleted": "Batch deleted",
    "toast.ingAdded": "Ingredient added",
    "toast.ingUpdated": "Ingredient updated",
    "toast.ingDeleted": "Ingredient deleted",
    "toast.photoUploaded": "Photo uploaded",
    "toast.selectCategory": "Select a category",
    "toast.selectBatch": "Select a batch",
    "toast.exported": "Exported {n} records",
    "toast.exportEmpty": "The list is empty — nothing to export.",
    "toast.exportFail": "Export failed",
    "toast.saveFail": "Saving failed",
    "toast.deleteFail": "Deletion failed",
    "toast.uploadFail": "Upload failed",
    "toast.sendFail": "Sending failed",
    "admin.tab.tags": "Tags",
    "admin.newTag": "New tag",
    "admin.noTags": "No tags yet",
    "tag.name": "Tag name",
    "tag.color": "Background color",
    "tag.create": "Create tag",
    "tag.save": "Save changes",
    "tag.editTitle": "Edit tag",
    "tag.createTitle": "New tag",
    "tag.preview": "Preview",
    "del.tag.title": "Delete this tag?",
    "del.tag.desc": "The tag will be removed from all ingredients that use it.",
    "id.tags": "Tags",
    "id.noTags": "First create tags in the “Tags” tab.",
    "toast.tagAdded": "Tag created",
    "toast.tagUpdated": "Tag updated",
    "toast.tagDeleted": "Tag deleted",
    "footer.lastUpdate": "Last system update:",
    "footer.tagline": "OPEN BATCH & MATERIALS REGISTRY",
  },
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;
    return saved === "en" || saved === "sk" ? saved : "sk";
  });

  const setLang = useCallback((l) => {
    setLangState(l);
    localStorage.setItem(STORAGE_KEY, l);
  }, []);

  const toggle = useCallback(() => {
    setLangState((prev) => {
      const next = prev === "sk" ? "en" : "sk";
      localStorage.setItem(STORAGE_KEY, next);
      return next;
    });
  }, []);

  const t = useCallback(
    (key, params) => {
      let str = translations[lang]?.[key] ?? translations.sk[key] ?? key;
      if (params) {
        Object.entries(params).forEach(([k, v]) => {
          str = str.replace(`{${k}}`, v);
        });
      }
      return str;
    },
    [lang]
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export const useLang = () => useContext(LanguageContext);
